var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowDsk1 = function SvgArrowDsk1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.845 15.454a1.5 1.5 0 002.31 1.913l-2.31-1.914zm60.901.956l-1.058 1.063 1.058-1.063zm83.686 13.111a1.5 1.5 0 00-.986-1.878l-12.89-4.013a1.5 1.5 0 00-.892 2.865l11.458 3.566-3.567 11.458a1.5 1.5 0 002.865.892l4.012-12.89zM3.155 17.367C7.49 12.13 15.586 5.847 25.695 4.022c10.002-1.807 22.206.71 34.993 13.45l2.117-2.124C49.401 1.99 36.233-.93 25.161 1.069 14.195 3.05 5.513 9.815.845 15.453l2.31 1.914zm57.533.106c33.46 33.342 73.602 18.396 84.009 12.93l-1.394-2.656c-10.054 5.28-48.482 19.504-80.498-12.4l-2.117 2.126z",
    fill: "#000"
  })));
};
export default SvgArrowDsk1;